import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map, List } from 'immutable';

import Popup from '../helpers/Popup';
import FetchingError from '../helpers/FetchingError';
import { InlineInput } from '../helpers/Input';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';
import Select from '../helpers/Select';
import withDoNothingOption from '../../hocs/withDoNothingOption';

const SelectWithDoNothingOption = withDoNothingOption(Select);

const MarkMailingCompletedPopup = props => {
  const {
    statusCodes,
    onUpdate,
    onClose,
    onStatusChange,
    onDateChange,
    formData,
    isPopupFetching,
    isPopupFetchingError,
  } = props;
  const header = 'Mark This Mailing as Completed';
  const footer = (
    <>
      <Button key="addTag" className="btn-primary" onClick={onUpdate}>
        Update
      </Button>
      <Button key="close" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="pushNextActionDatesPopup" loading={isPopupFetching}>
      <p>This will update all of these companies to indicate that this mailing was completed on the following date:</p>
      <div className="row">
        <FormGroup className="col-xs-6">
          <InlineInput
            label="Date"
            name="date"
            onChange={onDateChange}
            placeholder="date"
            type="date"
            value={formData.get('date')}
            autoFocus
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-xs-6">
          <SelectWithDoNothingOption
            id="mark-mailing-completed-status"
            label="New Status"
            name="nextActionStatus"
            onChange={onStatusChange}
            options={statusCodes}
            value={formData.getIn(['status', 'selected'])}
            showLabel
          />
        </FormGroup>
      </div>
      <FetchingError error={isPopupFetchingError} />
    </Popup>
  );
};

MarkMailingCompletedPopup.propTypes = {
  formData: PropTypes.instanceOf(Map).isRequired,
  onClose: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  statusCodes: PropTypes.instanceOf(List).isRequired,
};

export default memo(MarkMailingCompletedPopup);
